module.exports = __webpack_public_path__ + "img/male-teenager-foot.f1b2ee42.svg";